import React from 'react'
import {Col, Form, InputGroup, Row} from 'react-bootstrap'

import i18next from 'i18next'
import Select from 'react-select'
import {useTranslation} from 'react-i18next'
import {MultiSelect} from 'react-multi-select-component'
import CurrencyInput from 'react-currency-input-field'

type Prop = {
    separateValue3: (p1: any, p2: any, p3: any, p4: any) => void,
    fieldClearer: (p: any) => void,
    separateValue2: (p1: any, p2: any, p3: any) => void,
    separateValue: (p1: any, p2: any, p3: any) => void,
    getSectorDesc: (p1: any, p2: any, p3: any) => void,
    cityData: (p: any) => void,
    productTypeChange: (p: any) => void,
    setPname: (p: any) => void,
    setQuantum: (p: any) => void,
    setShipping: (p: any) => void,
    setketerangan: (p: any) => void,
    setEnduser: (p: any) => void,
    setEnduserDesc: (p: any) => void,
    setEnduserArray: (p: any) => void,
    setIsNoEnduser: (p: any) => void,
    setSektor: (p: any) => void,
    productNameChange: (p: any) => void,
    setNote: (p: any) => void,
    setSubprice: (p: any) => void,
    setFormulaPrice: (p: any) => void,
    setPspec: (p: any) => void,
    setIDSector: any,
    setSektorDesc: any,
    setIncoterm1: any,
    setIncoterm1Desc: any,
    setProdusen: any,
    setDistribution: any,
    setProdusenDesc: any,
    setPay1: any,
    setPay1Desc: any,
    setSegment: any,
    setSegmentDesc: any,
    setIncoterm2: any,
    setIncoterm2Desc: any,
    setCity: any,
    setCityDesc: any,
    setPay2: any,
    setPay2Desc: any,
    salesArea: any,
    idSektor: any,
    produsen: any,
    pnumber: any,
    language: any,
    test: any,
    arrayEnduser: any,
    roleUser: any,
    province: any,
    ptype: any,
    formulaPrice: any,
    isNoEnduser: boolean,
    fullProvince: any[],
    fullProductType: any[],
    fullIncoterm: any[],
    fullPayment: any[],
    fullSegment: any[],
    fullEndUser: any[],
    fullSector: any[],
    fullIncoterm2: any[],
    fullCity: any[],
    fullProductName: any[],
}

const FormCreateCorporation: React.FC<Prop> = ({
  separateValue3,
  fieldClearer,
  separateValue2,
  separateValue,
  getSectorDesc,
  cityData,
  productTypeChange,
  setPname,
  setQuantum,
  setShipping,
  setketerangan,
  setEnduser,
  setEnduserDesc,
  setEnduserArray,
  setIsNoEnduser,
  setSektor,
  productNameChange,
  setNote,
  setSubprice,
  setFormulaPrice,
  setPspec,
  setIDSector,
  setSektorDesc,
  setIncoterm1,
  setIncoterm1Desc,
  setProdusen,
  setDistribution,
  setProdusenDesc,
  setPay1,
  setPay1Desc,
  setSegment,
  setSegmentDesc,
  setIncoterm2,
  setIncoterm2Desc,
  setCity,
  setCityDesc,
  setPay2,
  setPay2Desc,
  salesArea,
  idSektor,
  produsen,
  pnumber,
  language,
  test,
  arrayEnduser,
  roleUser,
  province,
  ptype,
  formulaPrice,
  isNoEnduser,
  fullProvince,
  fullProductType,
  fullIncoterm,
  fullPayment,
  fullSegment,
  fullEndUser,
  fullSector,
  fullIncoterm2,
  fullCity,
  fullProductName,
}) => {
  const {t} = useTranslation()

  return (
    <>
      <Row>
        <Col md={6}>
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='fs-6 mt-3'>
                {t('sub-order-incoterm1')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              <Select
                key={produsen + idSektor}
                placeholder={t('pilih')}
                id='incoterm1'
                onChange={(e: any) => separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)}
                options={fullIncoterm}
              />
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {idSektor == 2 ? t('pickup-province') : t('sub-order-provinsi')}
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <Select
                key={idSektor + produsen}
                placeholder={t('pilih')}
                id='provinsi'
                onChange={(e: any) => cityData(e?.value)}
                options={fullProvince}
              />
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='fs-6 mt-3'>
                {t('sub-order-jenis')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              <Form.Select
                size='sm'
                aria-label='Default select example'
                id='jenis'
                onChange={(e: any) => productTypeChange(e.target.value)}
              >
                <option hidden value='~#~'>
                  {t('Pilih-productType')}
                </option>
                {fullProductType.map((item: any) => {
                  return (
                    <>
                      {item.id != 12 && (
                        <option value={item.material_group_desc + '~#~' + item.material_group}>
                          {t(item.material_group_desc)}
                        </option>
                      )}
                    </>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>

          {parseInt(pnumber) == 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='fs-6'>
                  Custom Product Name<span className='text-danger'>*</span>
                </p>
              </Col>
              <Col sm={8}>
                <Form.Control
                  placeholder='Custom Product Name'
                  size='sm'
                  aria-label='Default select example'
                  type='text'
                  id='custom'
                  onChange={(e: any) => setPname(e.target.value)}
                />
              </Col>
            </Row>
          )}

          <Row className='mb-4'>
            <Col sm={4}>
              <p className='fs-6 mt-3'>
                {t('Kuantum Pengajuan')}
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <InputGroup size='sm'>
                <CurrencyInput
                  className='form-control form-control-sm'
                  id='kuantum'
                  // key={pname}
                  placeholder={t('Kuantum Pengajuan')}
                  decimalSeparator={language === 'en' ? '.' : ','}
                  groupSeparator={language === 'en' ? ',' : '.'}
                  onValueChange={(value: any) => {
                    setQuantum(value?.replace(/,/g, '.'))
                  }}
                  decimalsLimit={2}
                />
                <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
              </InputGroup>
            </Col>
          </Row>

          <Row className='mb-2'>
            <Col sm={4} className='d-flex align-items-center'>
              <p className='fs-6'>{t('Shipping Tolerance')}</p>
            </Col>
            <Col sm={8}>
              <InputGroup className='mb-3' size='sm'>
                <Form.Control
                  type='number'
                  id='shipping'
                  placeholder={t('Shipping Tolerance')}
                  onChange={(e: any) => setShipping(parseInt(e.target.value))}
                />
                <InputGroup.Text
                  id='basic-addon2'
                  style={{paddingTop: '1px', paddingBottom: '1px'}}
                >
                  <span className='px-2'>%</span>
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {t('sub-order-payment1')}
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <Form.Select
                size='sm'
                aria-label='Default select example'
                id='payment1'
                onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
              >
                <option hidden value='~#~'>
                  {t('Pilih-payment')}
                </option>
                {fullPayment.map((item: any, index: number) => {
                  return (
                    <option key={item?.id ?? index} value={item.code + '~#~' + item.payment_desc_id}>
                      {item.payment_desc_id}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4} className='d-flex align-items-center'>
              <p className='fs-6'>{t('keterangan')}</p>
            </Col>
            <Col sm={8}>
              <Form.Control
                as='textarea'
                placeholder={t('keterangan')}
                defaultValue={test?.payment_note}
                id='keterangan'
                size='sm'
                style={{height: '40px'}}
                onChange={(e: any) => setketerangan(e.target.value)}
              />
            </Col>
          </Row>

          {parseInt(pnumber) != 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='mt-3 fs-6'>
                  {t('segment')}
                  <span className='text-danger'>*</span>{' '}
                </p>
              </Col>
              <Col sm={8}>
                <Form.Select
                  size='sm'
                  id='segment'
                  onChange={(e: any) => separateValue(setSegment, e.target.value, setSegmentDesc)}
                  aria-label='Default select example'
                >
                  <option selected hidden disabled value='~#~'>
                    {t('pilih')} {t('segment')}
                  </option>
                  {fullSegment.map((item: any) => {
                    if (item.code == 'Z2' || item.code == 'Z3') {
                      return <option value={item.code + '~#~' + item.name}>{item.name}</option>
                    } else {
                      return null
                    }
                  })}
                </Form.Select>
              </Col>
            </Row>
          )}

          <Row className=''>
            <Col sm={4}>
              <p className='fs-6 mt-3'>
                {t('End Customer')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              {isNoEnduser || idSektor == 2 ? (
                <>
                  <Form.Control
                    size='sm'
                    as='textarea'
                    id='enduser'
                    style={{height: '40px'}}
                    placeholder={t('End Customer')}
                    onChange={(e: any) => {
                      setEnduser(e.target.value)
                      setEnduserDesc(e.target.value)
                    }}
                  />
                </>
              ) : (
                <MultiSelect
                  options={fullEndUser?.map((item: any) => {
                    return {label: item.name, value: item.name}
                  })}
                  value={arrayEnduser}
                  onChange={(e: any) => setEnduserArray(e)}
                  labelledBy='Select'
                />
              )}
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4}></Col>
            <Col sm={8} className='d-flex align-items-center'>
              <Form.Check
                onClick={() => setIsNoEnduser(!isNoEnduser)}
                name='noenduser'
                // disabled={ptype == 'P13'}
                id='noenduser1'
                className='mt-5 mb-2'
                type='checkbox'
              />
              {i18next.language == 'en' ? (
                <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
              ) : (
                <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
              )}
            </Col>
          </Row>
        </Col>

        <Col md={6}>
          <Row className='mb-4' hidden={roleUser != 'salesAdmin' && idSektor != 1 ? true : false}>
            <Col sm={4}>
              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
            </Col>
            <Col sm={8}>
              <Select
                key={produsen + idSektor}
                placeholder={t('pilih')}
                id='incoterm2'
                onChange={(e: any) => {
                  separateValue2(setIncoterm2, e?.value, setIncoterm2Desc)
                }}
                options={fullIncoterm2}
              />
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {idSektor == 2 ? t('pickup-city') : t('sub-order-kota')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              <Select
                key={province}
                placeholder={t('pilih')}
                id='kota'
                onChange={(e: any) => {
                  separateValue2(setCity, e?.value, setCityDesc)
                  // fieldClearer(4)
                }}
                options={fullCity}
              />
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>
                {t('sub-order-produk')}
                <span className='text-danger'>*</span>
              </p>
            </Col>
            <Col sm={8}>
              <Select
                id='produk'
                placeholder={t('pilih')}
                key={ptype}
                onChange={(e: any) => {
                  productNameChange(e?.value)
                  // fieldClearer(1)
                }}
                options={fullProductName}
              />
            </Col>
          </Row>

          {parseInt(pnumber) == 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
              </Col>
              <Col sm={8}>
                <Form.Control
                  as='textarea'
                  placeholder={t('sub-order-catatan')}
                  id='note'
                  size='sm'
                  style={{height: '40px'}}
                  onChange={(e: any) => setNote(e.target.value)}
                />
              </Col>
            </Row>
          )}

          <Row className='mb-4'>
            <Col sm={4} className='d-flex align-items-center'>
              <p className='fs-6'>
                {t('Harga Pengajuan')}/Ton
                <span className='text-danger'>*</span>{' '}
              </p>
            </Col>
            <Col sm={8}>
              <InputGroup size='sm'>
                <InputGroup.Text id='basic-addon2'>
                  <span className='px-1'>Rp</span>
                </InputGroup.Text>
                <CurrencyInput
                  className='form-control form-control-sm'
                  id='hargap'
                  key={formulaPrice.toString()}
                  disabled={formulaPrice}
                  placeholder={formulaPrice ? '0' : t('Harga Pengajuan')}
                  decimalSeparator={language === 'en' ? '.' : ','}
                  groupSeparator={language === 'en' ? ',' : '.'}
                  onValueChange={(value: any) => {
                    setSubprice(value?.replace(/,/g, '.'))
                  }}
                  decimalsLimit={-1}
                />
              </InputGroup>
            </Col>
          </Row>

          <Row className='my-7'>
            <Col sm={6} className='d-flex '>
              <Row sm={8} className='d-flex align-items-center'>
                <p className='fs-6'>{t('termasuk-ppn')}</p>
              </Row>
              <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                <Form.Check reverse name='ppn' className='' type='checkbox' id='ckbox-ppn' />
              </Row>
            </Col>
            <Col sm={6} className='d-flex'>
              <Row sm={8} className='d-flex align-items-center'>
                <p className=' fs-6'>{t('Formulated Price')}</p>
              </Row>
              <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                <Form.Check
                  reverse
                  name='formula_Price'
                  className=''
                  type='checkbox'
                  onClick={() => {
                    setFormulaPrice(!formulaPrice)
                  }}
                  id='formula_Price'
                />
              </Row>
            </Col>
          </Row>

          <Row className='mb-4' hidden={roleUser != 'salesAdmin' && idSektor == 2 ? true : false}>
            <Col sm={4}>
              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
            </Col>
            <Col sm={8}>
              <Form.Select
                size='sm'
                aria-label='Default select example'
                id='payment2'
                onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
              >
                <option value='~#~'>{t('Pilih-payment')}</option>
                {fullPayment.map((item: any, index: number) => {
                  return (
                    <option
                      key={item?.code ?? index}
                      value={item.code + '~#~' + item.payment_desc_id}
                    >
                      {item.payment_desc_id}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={4}>
              <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
            </Col>
            <Col sm={8}>
              <Form.Control
                as='textarea'
                placeholder={t('sub-order-spek')}
                id='spek'
                size='sm'
                style={{height: '40px'}}
                onChange={(e: any) => setPspec(e.target.value)}
              />
            </Col>
          </Row>

          {parseInt(pnumber) != 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
              </Col>
              <Col sm={8}>
                <Form.Control
                  as='textarea'
                  placeholder={t('sub-order-catatan')}
                  id='note'
                  size='sm'
                  style={{height: '40px'}}
                  onChange={(e: any) => setNote(e.target.value)}
                />
              </Col>
            </Row>
          )}

          {parseInt(pnumber) == 0 && (
            <Row className='mb-4'>
              <Col sm={4}>
                <p className='mt-3 fs-6'>
                  {t('segment')}
                  <span className='text-danger'>*</span>{' '}
                </p>
              </Col>
              <Col sm={8}>
                <Form.Select
                  size='sm'
                  id='segment'
                  onChange={(e: any) => separateValue(setSegment, e.target.value, setSegmentDesc)}
                  aria-label='Default select example'
                >
                  <option selected hidden disabled value='~#~'>
                    {t('pilih')} {t('segment')}
                  </option>
                  {fullSegment.map((item: any) => {
                    if (item.code == 'Z2' || item.code == 'Z3') {
                      return <option value={item.code + '~#~' + item.name}>{item.name}</option>
                    } else {
                      return null
                    }
                  })}
                </Form.Select>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </>
  )
}

export {
  FormCreateCorporation
}
